import { render, staticRenderFns } from "./SpinnerWheel.vue?vue&type=template&id=0f39c296&scoped=true"
import script from "./SpinnerWheel.vue?vue&type=script&lang=ts"
export * from "./SpinnerWheel.vue?vue&type=script&lang=ts"
import style0 from "./SpinnerWheel.vue?vue&type=style&index=0&id=0f39c296&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0f39c296",
  null
  
)

export default component.exports